var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/RatesBulletinPopup/RatesBulletinPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/RatesBulletinPopup/RatesBulletinPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/RatesBulletinPopup/RatesBulletinPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
output += t_7;
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"RatesBulletinPopup\">\n\n         <div class=\"RatesBulletinPopup-header\">\n            <div class=\"RatesBulletinPopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 7, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:rates"])), env.opts.autoescape);
output += "\">Rates & Contracts</a></div>\n            <h2 class=\"RatesBulletinPopup-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"header")),"title"), env.opts.autoescape);
output += "</h2>\n        </div>\n\n        <div class=\"RatesBulletinPopup-bulletin\">\n            <div class=\"RatesBulletinPopup-bulletin-iframe RatesBulletinPopup-bulletin-iframe--loading\">\n                <iframe src=\"https://productionbulletin.com/new-database/\" border=\"0\" class=\"RatesBulletinPopup-bulletinIframeDatabase\"></iframe>\n            </div>\n            <div class=\"RatesBulletinPopup-bulletin-iframe RatesBulletinPopup-bulletin-iframe--loading\">\n                <iframe src=\"https://productionbulletin.com/new-weekly-project-report/\" border=\"0\" class=\"RatesBulletinPopup-bulletinIframeWeekly\"></iframe>\n            </div>\n        </div>\n\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/RatesBulletinPopup/RatesBulletinPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/RatesBulletinPopup/RatesBulletinPopup.jinja
// module id = 545
// module chunks = 0